import { type ChangeEvent, type ComponentType } from 'react';

import FormTextInput from './FormTextInput';

type TypedFormTextInputProps = {
  label: string;
  name: string;
  value: string | null;
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  classes?: { [key: string]: string };
  inputSize?: number;
  maxLength?: number;
  rows?: number;
  multiline?: boolean;
  [key: string]: unknown;
};

const TypedFormTextInput =
  FormTextInput as ComponentType<TypedFormTextInputProps>;

export default TypedFormTextInput;
